import { IDaysData } from '@df/catalog/store/store';

declare module '@df/checkout/checkout.interfaces' {
    namespace Checkout {
        interface IQuoteDataShippingAdditionalData {
            booking_code?: string;
            postcode?: string;
            country_id?: string;
            [key: string]: any;
        }
    }
}

export namespace Metapack {
    export const FIND_ENDPOINT = 'metapack/findStore';

    export const COLLECTION_POINT_TYPE = 'metapack_collection';

    export interface ICollectionPointData {
        latitude?: number;
        longitude?: number;
        distance?: number;
        phone?: string;
        store_name: string;
        city?: string;
        postcode: string;
        address?: string;
        days?: IDaysData;
        country_id: string;
        type: string;
        booking_code: string;
        collection_from?: string;
        collection_to?: string;
        delivery_from?: string;
        delivery_to?: string;
        region?: string;
        first_pickup_date?: string;
    }

    export interface IFindOne extends IFindByPostcodeData {
        booking_code: string;
    }

    export interface IFindByPostcodeData {
        postcode: string;
        country_id: string;
    }

    export interface IFindByGeolocationData {
        latitude: number;
        longitude: number;
    }

    export interface ICollectionPointSelectionData {
        booking_code: string;
        postcode: string;
        country_id: string;
        store_id: null;
    }
}
